export * from './baKameleonPicture.pipe';



// WEBPACK FOOTER //
// /opt/stranka/FrontOffice/src/app/theme/pipes/baKameleonPicture/index.ts